import { APIAccessor, HttpError, ListResponse } from '../utils/api';
import { BaseModel } from './base';
import { UserModel } from './user';

export class LinkModel extends BaseModel {
    public id = '';
    public url = '';
    public target = '';
    public owner = '';

    // eslint-disable-next-line unicorn/consistent-class-member-order -- conflicts with @typescript-eslint/member-ordering, which requires instance fields before static methods
    public static async getById(id: string, apiAccessor: APIAccessor): Promise<LinkModel | undefined> {
        try {
            const api = await apiAccessor.fetch(`/api/v1/links/${encodeURIComponent(id)}`);
            return this.wrapNew(api);
        } catch (error) {
            if (error instanceof HttpError && (error.status === 404 || error.status === 403)) {
                return undefined;
            }

            throw error;
        }
    }

    public static async getByUser(user: UserModel, apiAccessor: APIAccessor): Promise<LinkModel[]> {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
        const response = (await apiAccessor.fetch(
            `/api/v1/users/${encodeURIComponent(user.id)}/links`,
        )) as ListResponse;
        return response.items.map((link) => this.wrapNew(link));
    }

    public static async create(target: string, apiAccessor: APIAccessor): Promise<LinkModel> {
        const api = await apiAccessor.fetch('/api/v1/links', {
            method: 'POST',
            data: { target },
        });

        return this.wrapNew(api);
    }

    public static wrapNew(object: unknown): LinkModel {
        const link = new LinkModel();
        return link.wrap(object);
    }

    public async delete(apiAccessor: APIAccessor): Promise<void> {
        await apiAccessor.fetch(`/api/v1/links/${encodeURIComponent(this.id)}`, {
            method: 'DELETE',
        });
    }
}
